/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
var A;!function(A){A[A.ELEVATION=0]="ELEVATION",A[A.BASEMAP=1]="BASEMAP",A[A.I3S_INDEX=2]="I3S_INDEX",A[A.I3S_DATA=3]="I3S_DATA",A[A.SYMBOLOGY=4]="SYMBOLOGY"}(A||(A={}));const E=(()=>{const E=new Array;return E[A.ELEVATION]=10,E[A.BASEMAP]=10,E[A.I3S_INDEX]=10,E[A.I3S_DATA]=10,E[A.SYMBOLOGY]=5,E})(),I=30;export{A as ClientType,E as downloadSlotsPerClient,I as maxDownloadSlots};
